import { jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSLayoutTags } from '../../layout/types/index.esm.js';
import styles from '../../styles/uitk-egds-layout-position.css';
import { EGDSLayoutPositionTypes, EGDSLayoutPositionPointerEvents } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSLayoutPosition = props => {
  const {
    children,
    className,
    cloneElement,
    display,
    pointerEvents,
    position,
    style,
    tag,
    type,
    ...attributes
  } = props;
  const allowCustomPosition = React.useMemo(() => position && Object.values(position).some(v => typeof v === 'number') && type === EGDSLayoutPositionTypes.get('sticky'), [position, type]);
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  if (!firstChild || React.isValidElement(firstChild) === false) {
    return null;
  }
  const firstChildClassName = firstChild.props.className;
  const firstChildStyle = firstChild.props.style;
  const baseClass = 'uitk-layout-position';
  const wrapperClassNames = getClassNameList(baseClass, cloneElement && firstChildClassName && firstChildClassName, display && `${baseClass}-display-${display}`, pointerEvents && `${baseClass}-${EGDSLayoutPositionPointerEvents.get(pointerEvents)}`, position && Object.entries(position).filter(([, val]) => typeof val === 'string').map(([key, val]) => `${baseClass}-${key}-${val}`).join(' '), type && `${baseClass}-${EGDSLayoutPositionTypes.get(type)}`, allowCustomPosition && `${baseClass}-custom`, className);
  const wrapperStyle = {
    ...firstChildStyle,
    ...style
  };
  if (position && allowCustomPosition) {
    Object.entries(position).forEach(([key, val]) => {
      if (typeof val === 'number') {
        wrapperStyle[`--uitk-custom-${key}-position`] = `${val}px`;
      }
    });
  }
  const decoratedChild = React.cloneElement(firstChild, {
    className: wrapperClassNames,
    ...(Object.keys(wrapperStyle).length && {
      style: wrapperStyle
    }),
    ...attributes
  });
  const Tag = tag && EGDSLayoutTags.get(tag) || EGDSLayoutTags.get('div');
  return cloneElement ? decoratedChild : jsxs(Tag, {
    className: wrapperClassNames,
    ...attributes,
    style: wrapperStyle,
    children: [' ', children || null, ' ']
  });
};
EGDSLayoutPosition.displayName = 'EGDSLayoutPosition';
export { EGDSLayoutPosition };